export default {
  namespaced: true,
  state: {
    originPage: {
      currentPage: 1, 
      pagesize: 10, 
      total: 0,
    },
    advanceRes: [],
    businessId:'',//试题ID
  },
  mutations: {
    changeOriginPage(state, page) {
      state.originPage.currentPage = page
    },
    changeAdvance(state, advanceRes) {
      state.advanceRes = advanceRes
      state.total = advanceRes ? advanceRes.length : 0
    },
    changeBusinessId (state, businessId) {
      state.businessId = businessId
    },
  },
  actions: {

  },
}


// WEBPACK FOOTER //
// ./src/store/largeDatabase.js